import React, { FC } from 'react';
import { LuMail, LuGithub, LuLinkedin, LuInstagram, LuArrowUpRight, LuMessageCircle } from 'react-icons/lu';
import { FaGooglePlay } from 'react-icons/fa6';
import SectionTitle from './SectionTitle';
import { profile, whatsappMessage } from '../data/profile';

const links = [
  { icon: <LuMessageCircle size={22} />, label: 'WhatsApp', value: 'Chamar agora', href: whatsappMessage('Olá Bruno! Vi seu portfólio e gostaria de conversar sobre um projeto.') },
  { icon: <LuMail size={22} />, label: 'E-mail', value: profile.email, href: `mailto:${profile.email}` },
  { icon: <LuLinkedin size={22} />, label: 'LinkedIn', value: 'in/brunoaoliveiradev', href: profile.linkedin },
  { icon: <LuGithub size={22} />, label: 'GitHub', value: 'craniodatecnologia', href: profile.github },
  { icon: <FaGooglePlay size={19} />, label: 'Google Play', value: 'Crânio da Tecnologia', href: profile.playStore },
  { icon: <LuInstagram size={22} />, label: 'Instagram', value: '@brunoaoliveira.dev', href: profile.instagram },
];

const Contact: FC = () => (
  <section id="contato" className="section">
    <div className="container">
      <div className="cta reveal">
        <h2>Vamos tirar sua ideia do papel?</h2>
        <p>Conte o que você precisa e eu respondo com os próximos passos. Sem compromisso.</p>
        <a
          className="btn btn--light"
          href={whatsappMessage('Olá Bruno! Vi seu portfólio e gostaria de conversar sobre um projeto.')}
          target="_blank"
          rel="noreferrer"
        >
          <LuMessageCircle size={18} /> Iniciar conversa
        </a>
      </div>

      <SectionTitle eyebrow="Contato" title="Onde me encontrar" />
      <div className="grid grid--3">
        {links.map((l, i) => {
          const external = l.href.startsWith('http');
          return (
            <a
              key={l.label}
              className="card contact reveal"
              href={l.href}
              target={external ? '_blank' : undefined}
              rel={external ? 'noreferrer' : undefined}
              style={{ transitionDelay: `${i * 50}ms` }}
            >
              <span className="icon-tile">{l.icon}</span>
              <span className="contact__text">
                <strong>{l.label}</strong>
                <span>{l.value}</span>
              </span>
              <LuArrowUpRight className="contact__arrow" size={18} aria-hidden="true" />
            </a>
          );
        })}
      </div>
    </div>
  </section>
);

export default Contact;
